import React from "react";
import { Author } from "./types";
import { formatDate } from "../editorial/hooks";
// Author photo (or initials / a neutral mark), name, optional role and date.
// The same component is used on the article page, the Blog front page and
// every list, so one author always looks the same.
export function Avatar({ author, size = 36 }: { author: Author; size?: number }) {
  const style = { width: size, height: size, fontSize: Math.round(size * 0.38) };
  return author.photoUrl ? (
    <img className="bl-avatar" src={author.photoUrl} alt={author.photoAlt || author.name} style={style} />
  ) : (
    <span className="bl-avatar bl-avatar-initials" style={style} aria-hidden="true">
      {author.initials || "·"}
    </span>
  );
}
export default function Byline({
  author,
  date,
  size = 36,
}: {
  author: Author;
  date?: string | null;
  size?: number;
}) {
  return (
    <div className="bl-byline">
      <Avatar author={author} size={size} />
      <div>
        <span className="bl-author">{author.name}</span>
        {author.role && <span className="bl-role">{author.role}</span>}
        {date !== undefined && (
          <span className="bl-date">{date ? formatDate(date) : "Not yet published"}</span>
        )}
      </div>
    </div>
  );
}
